import { ReactNode, useEffect, useReducer, useRef } from "react";

import { registerMemoryStatsProvider } from "utils/memoryDiagnostics";

import { DispatchContext, initialState, LazyStateContext, reducer, StateContext } from "./reducer";

export function SelectionBasketProvider({ children }: { children: ReactNode }) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const lazyValue = useRef(state);
    lazyValue.current = state;

    useEffect(() => {
        return registerMemoryStatsProvider("selectionBasketState", () => ({
            idCount: lazyValue.current.ids.size,
            // ids and idArr share one sorted Uint32Array (4 bytes/id).
            residentBytes: lazyValue.current.ids.sortedIds.byteLength,
        }));
    }, []);

    return (
        <StateContext.Provider value={state}>
            <LazyStateContext.Provider value={lazyValue}>
                <DispatchContext.Provider value={dispatch}>{children}</DispatchContext.Provider>
            </LazyStateContext.Provider>
        </StateContext.Provider>
    );
}
